import Vue from 'vue';
export const PlayerEvent = new Vue();

/*Register event:
	mapInitialized: emit: Map.vue, on: Detail
	playerUpdate: emit: Detail, on: Map.vue
	playerChangedProcess: emit: Detail, on Map.vue
	playVideo: emit: Detail, on Map.vue
	stopVideo: emit: Detail, on Map.vue
*/